import React from 'react';
import { Modal, Button, Row} from 'react-bootstrap';
import '../Pages.css';

export const ActivityCancelAllForm = ({ showModal, closeModal }) => {

  const cancel = () => {
    closeModal(0);
  };
  const closeOne = () => {
    closeModal(1);
  };
  const closeAll = () => {
    closeModal(2);
  };

  return (
    <>
      <Modal show={showModal} onHide={closeModal} dialogClassName="activity-filter-modal" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>
            Cancel Options
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          {/*row 1*/}
          <Row className='mb-3'>
            <h5>This Occurrence Only or This and All Remaining Occurrences?</h5>
          </Row>

          {/*row 2*/}
          <Row className='mb-3'>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancel}>
            Do Nothing
          </Button>
          <Button variant="primary" onClick={closeOne}>
            Cancel This Occurrence Only
          </Button>
          <Button variant="primary" onClick={closeAll}>
            Cancel This and All Remaining Occurrences
          </Button>
        </Modal.Footer>
      </Modal>

      
    </>
  );
}